import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { PageHero } from '../components/PageHero';
import { SEO } from '../components/SEO';
import { Shield } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO page="datenschutz" />
      <Navbar />
      <main className="flex-1">
        
        {/* Einheitlicher Hero mit PageHero Komponente */}
        <PageHero
          title="Datenschutzerklärung"
          subtitle="Informationen zur Verarbeitung Ihrer personenbezogenen Daten"
          badges={[
            { icon: Shield, text: 'DSGVO-konform', bgColor: 'bg-blue-600 text-white' },
            { text: 'Ihre Daten sind sicher', variant: 'white' }
          ]}
          backgroundImage="https://customer-assets.emergentagent.com/job_erste-hilfe-portal/artifacts/se7o920v_034BF087-9EB9-40DB-855B-A66F6E38EAAA.png"
          backgroundPosition="center 40%"
          variant="simple"
        />

        {/* INHALT - Same container width as navbar */}
        <section className="py-12 sm:py-16">
          <div className="max-w-[1664px] mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none text-slate-600 space-y-6">
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Datenerfassung auf dieser Website</h3>
              <p>
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur verantwortlichen Stelle" 
                in dieser Datenschutzerklärung entnehmen.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">2. Hosting</h2>
              <p>
                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                Die Server des Hosters befinden sich in Deutschland.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den 
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p>
                Erste Hilfe Germany GbR<br />
                Poststraße 6<br />
                46236 Bottrop<br />
                Deutschland
              </p>
              <p>
                <strong>Vertretungsberechtigte Gesellschafter:</strong><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel
              </p>
              <p>
                Telefon: 02041 9878 666<br />
                E-Mail: info@erstehilfebottrop.de
              </p>
              <p>
                Die Gesellschaft wird durch die Gesellschafter gemeinschaftlich vertreten.<br />
                Beide Gesellschafter haften im Rahmen der gesetzlichen Vorschriften.
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Verantwortlich im Sinne des § 18 MStV</h3>
              <p>
                Verantwortlich für den Inhalt:<br /><br />
                Herr Yasar Kartal<br />
                Herr Jan Hassel<br />
                Poststraße 6<br />
                46236 Bottrop
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
                Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit 
                der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#1e3a5f] mt-8 mb-4">4. Datenerfassung auf dieser Website</h2>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus 
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              
              <h3 className="text-xl font-semibold text-[#1e3a5f] mt-6 mb-3">Anfrage per E-Mail, Telefon oder Telefax</h3>
              <p>
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage 
                inklusive aller daraus hervorgehenden personenbezogenen Daten zum Zwecke der 
                Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
              </p>
            </div>
          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default DatenschutzPage;
